import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Roles } from '../models/enums/roles.enum';
import { AuthService } from '../services/auth.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { StoreChangesService } from '../services/store-changes.service';

@Injectable({ providedIn: 'root' })
export class PerventCoustoumEmailGuard {
  constructor(private router: Router, private authServ: AuthService, private messageService: MessageService, private storeChanges: StoreChangesService,) { }

  canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  const { admin, employee1, employee2, employee3 } = Roles;
  const accessRoles: string[] = [admin, employee1, employee2, employee3];

  return this.storeChanges.getUser().pipe(
    switchMap((response) => {
      if (response) {
        if (response.email !== 'card4games2000+1@gmail.com') {
          return of(true);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Not allowed to enter this link or not found',
          });
          return of(false);
        }
      } else {
        return this.authServ.validateAdmin().pipe(
          map((res) => {
            if (res) {
              return true;
            } else {
              this.router.navigateByUrl('/auth/login');
              return false;
            }
          }),
          catchError(() => {
            this.router.navigateByUrl('/auth/login');
            return of(false);
          })
        );
      }
    })
  );
}
}
